import DEFAULT from '@/config/premadeConfigs'
import { PartnerConfig } from '@/types'

const { LOGOS, USA } = DEFAULT
const {
  CONTENT_WITH_FAMILY_AND_ELIGIBILITY_V2: content,
  CONFIG_WITH_FAMILY_AND_ELIGIBILITY_V2,
} = USA

const partnerName = 'Fidelis NY Medicaid'

const baseConfig: PartnerConfig = {
  branding: {
    logo: [LOGOS.BABYLON],
  },
  config: {
    ...CONFIG_WITH_FAMILY_AND_ELIGIBILITY_V2,
    id: 'fidelis-medicaid',
    productConfigAppName: 'fidelis-medicaid',
    name: partnerName,
    codes: {
      membership: 'fidelismedicaidautoapp',
    },
    partnerUrlSlug: 'fidelisny',
  },
  content,
}

const baseConfigWithDnaV2Design: PartnerConfig = {
  ...baseConfig,
  config: {
    ...baseConfig.config,
    useDnaV2Design: true,
  },
}

export default [baseConfig, baseConfigWithDnaV2Design]
